<template>
    <section class="hero is-info is-small header">
      <div class="hero-body">
        <div class="container m-y-xl p-l-md">
            <h1 class="title">
            {{pageTitle}}
            </h1>
        </div>
      </div>
    </section>
</template>

<script>
export default {
  name: 'HeaderSmall',
  props: {
    pageTitle: String
  }
}
</script>

<style scoped>
  li{
    text-transform: capitalize;
  }

  .title{
    font-size: 3.5rem;
  }

  .subtitle{
    font-size: 1.6rem;
  }

  .hero{
    background: url("/images/header_bg.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    /* background-position: center; */
  }
/* .hero-body{
  padding: 1.5rem 1.5rem;
} */
@media screen and (min-width: 769px){
  /* .hero.is-medium .hero-body {
      padding-bottom: 2rem;
      padding-top: 2rem;
  } */
  .title{
    color: #fff!important;
  }
  .subtitle{
    color: #215D63!important;
  }
  
}
</style>